import { Close, Visibility, VisibilityOff } from "@mui/icons-material";
import { Autocomplete, Avatar, Backdrop, Button, FormControl, FormControlLabel, FormLabel, Grid, IconButton, Radio, RadioGroup, TextField, Typography } from "@mui/material";
import axios from "axios";
import { useFormik } from "formik";
import React, { Fragment, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as yup from "yup";
import Logo from "../../assets/images/logo.jpeg";
import { setSnackbar } from "../../components/hooks/snackBar/reducers";
import CustomTextField from "../../components/utils/input/customTextField";
import { useStyle } from "./style";
import Loader from "../../components/loader/loader";
import { Helmet } from "react-helmet-async";
import Wrong from "../../components/utils/errorPage/wrong";

const Login = () => {
  const classes = useStyle();
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const [showPassword, setShowPassword] = useState(false);
  const [isLoader, setIsLoader] = useState(false); //loader
  const [open, setOpen] = useState(false)
  const [type, setType] = useState('')
  const [roles, setRoles] = useState([])
  const [outlet, setOutlet] = useState([])
  const [flag, setFlag]  = useState(true)
  const [selectedOutlet , setSelectedOutlet] = useState(null)
  const validationSchema = yup.object({
    email: yup
      .string("Enter your email")
      .required("Email or Username is required"),
    password: yup
      .string("Enter your password")
      .min(5, "Password should be of minimum 8 characters length")
      .required("Password is required"),
  });

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: validationSchema,
    onSubmit: handleLogin,
  });

  function handleLogin() {
    setIsLoader(false)
    axios
      .post("/v1/users/login", {
        email: formik.values.email,
        password: formik.values.password,
      })
      .then((res) => {
       if(res.status===200){
        // setIsLoader(true)
        console.log(res)
        localStorage.setItem("token", res.data.token);
        if(res.data.token){
          axios.defaults.headers.common['Authorization'] = `Bearer ${res.data.token}`
              // navigate("/dashboard")
              setOpen(true)
              getRoles()
        }
        }
      })
      .catch((err) => {
        setIsLoader(false)
        dispatch(setSnackbar(true,'error', err.response.data.errors[0].message))
      });
  }

  const handleEnter = (e) => {
    if (e.key === "Enter") {
      // formik.handleSubmit()
      handleCheckType()
    }
  };

  function handleType(e){
  setType(e.target.value)
  }
  console.log(type,'Type Value')

  function handleCheckType(){
    console.log(type,'Type Value')
    formik.handleSubmit()
    // if(type==='outlet' || type==='warehouse'){
    // }
    // else{
    //   dispatch(setSnackbar(true, 'error', 'Choose any user type!'))
    // }

  }
  function getRoles(){
    axios.get('v1/users/info/1')
    .then(res=>{
      console.log(res.data)
      setRoles(res.data.roles)
      setOutlet(res.data.outlets)
      localStorage.setItem('username',res.data.user_name)
      localStorage.setItem('userId',res.data.id)

      // localStorage.setItem('user_id', res.data.id)
      // const user_data ={
      //   user_name : res.data.user_name,
      //   mobile : res.data.user_mobile,
      //   email : res.data.user_email,
      //   user_type : res.data.user_type
      // }
      // localStorage.setItem('user_data', user_data)
    })
  }
console.log(outlet)
  function handleChange(value){
    console.log(value)
    if (value) {
      console.log('Selected Role:', value.role_name);
    }
    localStorage.setItem('role_id' , value.id)
    navigate('/dashboard')
    dispatch(setSnackbar(true, 'success', 'Sign up successful!'))
  }
  useEffect(()=>{
if(!open){
  localStorage.clear()
  setOutlet([])
  setSelectedOutlet(null)
  setFlag(true)
}

  },[open])
  console.log(roles)
  return (
    <Fragment>
      <Helmet>
        <title>Login</title>
      </Helmet>
 <div className="w-full h-dvh flex justify-center items-center ">
      <Grid className={classes.mainGrid}>
        <Avatar variant="square" src={Logo} className={classes.logo}/>
       
         {/* <FormControl>
         <FormLabel >Welcome! Please select your user type to continue:</FormLabel>
         <RadioGroup row value={type} className="flex justify-center" onChange={handleType}>
          <FormControlLabel value="warehouse" control={<Radio size="small"/>} label="Warehouse" />
          <FormControlLabel value="outlet" control={<Radio size="small"/>} label="Outlet" />
          </RadioGroup>
         </FormControl> */}
        <CustomTextField
          id="email"
          title="Username or Email"
          value={formik.values.email}
          onchange={formik.handleChange}
          multiple={false}
          errorMsg={formik.touched.email && Boolean(formik.errors.email)}
          helperText={formik.touched.email && formik.errors.email}
          placeholder='Enter Username or Email'
        />
        <Typography fontSize={18} marginBlock={0.8}>Password</Typography>
        <TextField
            id="password"
            type={showPassword ? "text" : "password"}
            placeholder="Password *"
            value={formik.values.password}
            fullWidth
            size="small"
            onKeyPress={(e) => handleEnter(e)}
            onChange={formik.handleChange}
            autoComplete="new-password"
            InputProps={{
              endAdornment: (
                <IconButton onClick={() => setShowPassword(!showPassword)}>
                  {showPassword ? <Visibility /> : <VisibilityOff/>}
                </IconButton>
              ),
            }}
            error={formik.touched.password && Boolean(formik.errors.password)}
            helperText={formik.touched.password && formik.errors.password}
          />
        <Button
          variant="contained"
          sx={{ marginBlock: 2 }}
          fullWidth
          onClick={handleCheckType}
        >
          Sign In
        </Button>
      </Grid>
      <Backdrop open={open} sx={{zIndex : 1250}}>
            <Grid className="p-3 bg-white w-1/4 h-fit relative">
              <IconButton sx={{position: 'absolute', top:0, right : 0}} onClick={()=>{setOpen(false);}}><Close/></IconButton>
              {/* {type==='warehouse' ?  */}
              
              <Grid >
                {outlet.length > 0 && 
                <>
                <Typography fontWeight={600} variant="h6">Choose Outlet</Typography>
                 <Autocomplete 
                id="outlet"
                sx={{marginBlock: 1}}
                options={outlet}
                size="small"
                disableClearable
                autoComplete={false}
                value={selectedOutlet}
                getOptionLabel={option => option.fullname}
                isOptionEqualToValue={(option, value)=> option.id === value.id}
                onChange={(e, value)=>{
                  console.log(e , value)
                  localStorage.setItem('outlet_id', value.id)
                  localStorage.setItem('outlet_name' , value.fullname)
                  setFlag(false)
                  setSelectedOutlet(value)
                }}
                renderInput={(params)=>(
                  <TextField 
                  {...params}
                  placeholder="Select Outlet"
                  />
                )}
                />
                </>
                }
                
                <Typography fontWeight={600} variant="h6">Choose a Role to continue</Typography>
                <Autocomplete 
                id="roles"
                options={roles}
                disableClearable
                size="small"
                autoComplete={false}
                disabled={outlet.length > 0 && flag }
                getOptionLabel={option => option.role_name}
                isOptionEqualToValue={(option, value)=> option.id === value.id}
                onChange={(e, value)=> handleChange(value)}
                renderInput={(params)=>(
                  <TextField 
                  {...params}
                  placeholder="Select Role"
                  />
                )}
                />

              </Grid> 
             
            </Grid>
      </Backdrop>
      <Loader isLoader={isLoader}/>
    </div>
    {/* <Wrong /> */}
    </Fragment>
   
  );
};

export default Login;

// const Login = () => {
//   const classes = useStyle();
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const [showPassword, setShowPassword] = useState(false);
//   const [isLoader, setIsLoader] = useState(false);
//   const [outlet, setOutlet] = useState([]);
//   const [roles, setRoles] = useState([]);
//   const [selectedOutlet, setSelectedOutlet] = useState(null);
//   const [flag, setFlag] = useState(true);
//   const [type, setType] = useState('');
  
//   // New state to control showing outlet and role fields
//   const [showOutletRoleFields, setShowOutletRoleFields] = useState(false);

//   const validationSchema = yup.object({
//     email: yup.string("Enter your email").required("Email or Username is required"),
//     password: yup.string("Enter your password").min(8, "Password should be at least 8 characters").required("Password is required"),
//   });

//   const formik = useFormik({
//     initialValues: {
//       email: "",
//       password: "",
//     },
//     validationSchema: validationSchema,
//     onSubmit: handleLogin,
//   });

//   function handleLogin() {
//     setIsLoader(true);
//     axios
//       .post("/v1/users/login", {
//         email: formik.values.email,
//         password: formik.values.password,
//       })
//       .then((res) => {
//         if (res.status === 200) {
//           localStorage.setItem("token", res.data.token);
//           if (res.data.token) {
//             axios.defaults.headers.common['Authorization'] = `Bearer ${res.data.token}`;
//             // Fetch roles and outlets after login
//             getRoles();
//           }
//         }
//       })
//       .catch((err) => {
//         setIsLoader(false);
//         dispatch(setSnackbar(true, 'error', err.response.data.errors[0].message));
//       });
//   }

//   function getRoles() {
//     axios.get('v1/users/info/1')
//       .then((res) => {
//         setRoles(res.data.roles);
//         setOutlet(res.data.outlets);
//         localStorage.setItem('username', res.data.user_name);
//         localStorage.setItem('userId', res.data.id);
        
//         // Show outlet and role fields after successful login
//         setShowOutletRoleFields(true);
//         setIsLoader(false);
//       });
//   }

//   function handleSelectOutlet(value) {
//     localStorage.setItem('outlet_id', value.id);
//     localStorage.setItem('outlet_name', value.fullname);
//     setSelectedOutlet(value);
//     setFlag(false);
//   }

//   function handleSelectRole(value) {
//     localStorage.setItem('role_id', value.id);
//     navigate('/dashboard');
//     dispatch(setSnackbar(true, 'success', 'Sign up successful!'));
//   }

//   return (
//     <Fragment>
//       <Helmet>
//         <title>Login</title>
//       </Helmet>
//       <div className="w-full h-dvh flex justify-center items-center">
//         <Grid className={classes.mainGrid}>
//           <Avatar variant="square" src={Logo} className={classes.logo} />

//           <CustomTextField
//             id="email"
//             title="Username or Email"
//             value={formik.values.email}
//             onchange={formik.handleChange}
//             multiple={false}
//             errorMsg={formik.touched.email && Boolean(formik.errors.email)}
//             helperText={formik.touched.email && formik.errors.email}
//             placeholder="Enter Username or Email"
//           />

//           <Typography fontSize={18} marginBlock={0.8}>Password</Typography>
//           <TextField
//             id="password"
//             type={showPassword ? "text" : "password"}
//             placeholder="Password *"
//             value={formik.values.password}
//             fullWidth
//             size="small"
//             onChange={formik.handleChange}
//             InputProps={{
//               endAdornment: (
//                 <IconButton onClick={() => setShowPassword(!showPassword)}>
//                   {showPassword ? <Visibility /> : <VisibilityOff />}
//                 </IconButton>
//               ),
//             }}
//             error={formik.touched.password && Boolean(formik.errors.password)}
//             helperText={formik.touched.password && formik.errors.password}
//           />

//           {/* Outlet and Role selection fields */}
//           {showOutletRoleFields && (
//             <>
//             <Typography fontWeight={600} variant="h6">Choose Outlet</Typography>
//               <Autocomplete
//                 id="outlet"
//                 options={outlet}
//                 size="small"
//                 disableClearable
//                 value={selectedOutlet}
//                 getOptionLabel={(option) => option.fullname}
//                 onChange={(e, value) => handleSelectOutlet(value)}
//                 renderInput={(params) => (
//                   <TextField {...params} placeholder="Select Outlet" />
//                 )}
//               />
//               <Typography fontWeight={600} variant="h6">Choose a Role to continue</Typography>
//               <Autocomplete
//                 id="roles"
//                 options={roles}
//                 size="small"
//                 disableClearable
//                 disabled={outlet.length > 0 && flag}
//                 getOptionLabel={(option) => option.role_name}
//                 onChange={(e, value) => handleSelectRole(value)}
//                 renderInput={(params) => (
//                   <TextField {...params} placeholder="Select Role" />
//                 )}
//               />
//             </>
//           )}

//           <Button
//             variant="contained"
//             sx={{ marginBlock: 2 }}
//             fullWidth
//             onClick={formik.handleSubmit}
//             disabled={showOutletRoleFields && (!selectedOutlet || flag)}
//           >
//             Sign In
//           </Button>
//         </Grid>
//       </div>
//       <Loader isLoader={isLoader} />
//     </Fragment>
//   );
// };

// export default Login;
// const Login = () => {
//   const classes = useStyle();
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const [showPassword, setShowPassword] = useState(false);
//   const [isLoader, setIsLoader] = useState(false);
//   const [outlet, setOutlet] = useState([]);
//   const [roles, setRoles] = useState([]);
//   const [selectedOutlet, setSelectedOutlet] = useState(null);
//   const [flag, setFlag] = useState(true);
//   const [type, setType] = useState('');

//   // New state to control showing outlet and role fields
//   const [showOutletRoleFields, setShowOutletRoleFields] = useState(false);
  
//   // New state to control disabling password field
//   const [isPasswordDisabled, setIsPasswordDisabled] = useState(false); 

//   const validationSchema = yup.object({
//     email: yup.string("Enter your email").required("Email or Username is required"),
//     password: yup.string("Enter your password").min(8, "Password should be at least 8 characters").required("Password is required"),
//   });

//   const formik = useFormik({
//     initialValues: {
//       email: "",
//       password: "",
//     },
//     validationSchema: validationSchema,
//     onSubmit: handleLogin,
//   });

//   function handleLogin() {
//     setIsLoader(true);
//     axios
//       .post("/v1/users/login", {
//         email: formik.values.email,
//         password: formik.values.password,
//       })
//       .then((res) => {
//         if (res.status === 200) {
//           localStorage.setItem("token", res.data.token);
//           if (res.data.token) {
//             axios.defaults.headers.common['Authorization'] = `Bearer ${res.data.token}`;
//             // Fetch roles and outlets after login
//             getRoles();
//             // Disable password field after successful login
//             setIsPasswordDisabled(true); 
//           }
//         }
//       })
//       .catch((err) => {
//         setIsLoader(false);
//         dispatch(setSnackbar(true, 'error', err.response.data.errors[0].message));
//       });
//   }

//   function getRoles() {
//     axios.get('v1/users/info/1')
//       .then((res) => {
//         setRoles(res.data.roles);
//         setOutlet(res.data.outlets);
//         localStorage.setItem('username', res.data.user_name);
//         localStorage.setItem('userId', res.data.id);
        
//         // Show outlet and role fields after successful login
//         setShowOutletRoleFields(true);
//         setIsLoader(false);
//       });
//   }

//   function handleSelectOutlet(value) {
//     localStorage.setItem('outlet_id', value.id);
//     localStorage.setItem('outlet_name', value.fullname);
//     setSelectedOutlet(value);
//     setFlag(false);
//   }

//   function handleSelectRole(value) {
//     localStorage.setItem('role_id', value.id);
//     navigate('/dashboard');
//     dispatch(setSnackbar(true, 'success', 'Sign up successful!'));
//   }

//   return (
//     <Fragment>
//       <Helmet>
//         <title>Login</title>
//       </Helmet>
//       <div className="w-full h-dvh flex justify-center items-center">
//         <Grid className={classes.mainGrid}>
//           <Avatar variant="square" src={Logo} className={classes.logo} />
// {/* 
//           <CustomTextField
//             id="email"
//             title="Username or Email"
//             value={formik.values.email}
//             onchange={formik.handleChange}
//             multiple={false}
//             errorMsg={formik.touched.email && Boolean(formik.errors.email)}
//             helperText={formik.touched.email && formik.errors.email}
//             placeholder="Enter Username or Email"
//             disabled={isPasswordDisabled}
//             // Keep this field enabled at all times
//           /> */}
//             <Typography fontSize={18} marginBlock={0.8}>Username or Email</Typography>
// <TextField
//           id="email"
       
//           value={formik.values.email}
//           onChange={formik.handleChange}
//           error={formik.touched.email && Boolean(formik.errors.email)}
//           helperText={formik.touched.email && formik.errors.email}
//           placeholder="Enter Username or Email"
//           // disabled={isEmailDisabled} // Disable this field based on state
//           fullWidth // Optional: Makes the TextField full width
//           size="small" // Optional: Adjust size as needed
//           disabled={isPasswordDisabled}
//         />


//           <Typography fontSize={18} marginBlock={0.8}>Password</Typography>
//           <TextField
//             id="password"
//             type={showPassword ? "text" : "password"}
//             placeholder="Password *"
//             value={formik.values.password}
//             fullWidth
//             size="small"
//             onChange={formik.handleChange}
//             InputProps={{
//               endAdornment: (
//                 <IconButton onClick={() => setShowPassword(!showPassword)}>
//                   {showPassword ? <Visibility /> : <VisibilityOff />}
//                 </IconButton>
//               ),
//             }}
//             error={formik.touched.password && Boolean(formik.errors.password)}
//             helperText={formik.touched.password && formik.errors.password}
//             disabled={isPasswordDisabled} // Disable password field based on state
//           />

//           {/* Outlet and Role selection fields */}
//           {showOutletRoleFields && (
//             <>
//               <Typography fontWeight={600} variant="h6">Choose Outlet</Typography>
//               <Autocomplete
//                 id="outlet"
//                 options={outlet}
//                 size="small"
//                 disableClearable
//                 value={selectedOutlet}
//                 getOptionLabel={(option) => option.fullname}
//                 onChange={(e, value) => handleSelectOutlet(value)}
//                 renderInput={(params) => (
//                   <TextField {...params} placeholder="Select Outlet" />
//                 )}
//               />
//               <Typography fontWeight={600} variant="h6">Choose a Role to continue</Typography>
//               <Autocomplete
//                 id="roles"
//                 options={roles}
//                 size="small"
//                 disableClearable
//                 disabled={outlet.length > 0 && flag}
//                 getOptionLabel={(option) => option.role_name}
//                 onChange={(e, value) => handleSelectRole(value)}
//                 renderInput={(params) => (
//                   <TextField {...params} placeholder="Select Role" />
//                 )}
//               />
//             </>
//           )}

//           <Button
//             variant="contained"
//             sx={{ marginBlock: 2 }}
//             fullWidth
//             onClick={formik.handleSubmit}
//             disabled={showOutletRoleFields && (!selectedOutlet || flag)}
//           >
//             Sign In
//           </Button>
//         </Grid>
//       </div>
//       <Loader isLoader={isLoader} />
//     </Fragment>
//   );
// };

// export default Login;  
